import {
  Bar, Pie, Line, mixins
} from 'vue-chartjs'

const chartAdapter = {
  props: ['chartData', 'options'],
  mixins: [mixins.reactiveProp],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options)
    },
    options() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
export const BarChart = Bar.extend(chartAdapter)
export const PieChart = Pie.extend(chartAdapter)
export const LineChart = Line.extend(chartAdapter)



// WEBPACK FOOTER //
// ./src/components/common/Charts.js